import ApiService from './ApiService'
import axios from '../config/axios'

class FashionApiService {
  private static readonly BASE_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders`
  private static readonly ORDERS_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders`

  static async get(endpoint: string, params?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.get(url, params, config)
  }

  static async post(endpoint: string, data?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.post(url, data, config)
  }

  static async put(endpoint: string, data?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.put(url, data, config)
  }

  static async patch(endpoint: string, data?: any, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.patch(url, data, config)
  }

  static async delete(endpoint: string, config?: any) {
    const url = `${this.BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`
    return ApiService.delete(url, config)
  }

  static async getFashionOrders(page: number = 0, size: number = 10) {
    const pageOneBased = page + 1;
    const url = `${this.ORDERS_URL}/order/paginated?page=${pageOneBased}&limit=${size}&onlyActive=true`
    return ApiService.get(url)
  }

  static async getFashionOrdersCount() {
    const url = `${this.ORDERS_URL}/order/paginated?page=1&limit=1&onlyActive=true`
    return ApiService.get(url)
  }

  static async getFashionProducts(page: number, size: number, status?: boolean) {
    let endpoint = `/fashion-product/paginated?page=${page}&size=${size}`
    if (status !== undefined) {
      endpoint += `&status=${status}`
    }
    return this.get(endpoint)
  }

  static async updateFashionProduct(productId: number, data: any) {
    return this.put(`/fashion-product/${productId}`, data)
  }

  static async getFamilyColors(familyId: number) {
    return this.get(`/fashion-product/families/${familyId}/colors`)
  }

  static async searchFamilies(name: string) {
    return this.get(`/fashion-product/families?name=${encodeURIComponent(name)}`)
  }

  static async searchGroups(name: string) {
    return this.get(`/fashion-product/groups?name=${encodeURIComponent(name)}`)
  }

  static async getProductionOrders(page: number = 0, size: number = 10) {
    const skip = page * size;
    return this.get(`/fashion-production-orders?skip=${skip}&take=${size}`)
  }

  static async getProductionOrdersCount() {
    return this.get('/fashion-production-orders/count')
  }

  static async getProductionOrderById(orderId: number) {
    return this.get(`/fashion-production-orders/${orderId}`)
  }

  static async updateProductionOrder(orderId: number, data: any) {
    return this.patch(`/fashion-production-orders/${orderId}`, data)
  }

  static async deleteProductionOrders(ids: number[]) {
    return this.delete('/fashion-production-orders', { data: { ids } })
  }

  static async getUsers(role?: string) {
    const endpoint = role ? `/users?role=${encodeURIComponent(role)}` : '/users'
    return this.get(endpoint)
  }

  static async getStages() {
    return this.get('/stages')
  }

  static async getPaymentConditions() {
    return { data: [] }
  }

  static async getShippingTypes() {
    return { data: [] }
  }
}

export default FashionApiService